import { useEffect } from 'react'
import { useTheme } from '../contexts/ThemeContext'

/**
 * Hook that dynamically injects theme colors into CSS variables
 * This allows us to use the colors from API throughout the app
 */
export function useDynamicColors() {
  const { primaryColor, secondaryColor } = useTheme()

  useEffect(() => {
    // Get root element
    const root = document.documentElement

    // Helper function to convert hex to RGB
    const hexToRgb = (hex: string) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : { r: 196, g: 69, b: 54 } // Default fallback
    }

    // Set primary color
    if (primaryColor) {
      root.style.setProperty('--primary', primaryColor)
      
      // Set primary color variations
      const rgb = hexToRgb(primaryColor)
      root.style.setProperty('--primary-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`)
      
      // Set hover state (slightly darker)
      root.style.setProperty('--primary-hover', primaryColor + 'E6') // 90% opacity
      
      // Set focus ring color (lighter for accessibility)
      root.style.setProperty('--primary-focus', primaryColor + '40') // 25% opacity
    }

    // Set secondary color
    if (secondaryColor) {
      root.style.setProperty('--secondary', secondaryColor)
      
      const rgb = hexToRgb(secondaryColor)
      root.style.setProperty('--secondary-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`)
    }
  }, [primaryColor, secondaryColor])
}

